import React, { Component, createRef } from 'react';
import Validator from 'validatorjs';
import { Redirect, Link } from 'react-router-dom';
import * as QueryString from 'query-string';
import { Form, Row, Col, Image } from 'react-bootstrap';

import './Auth.css';

import { Http } from '../../support';
import { Auth } from '../../support';
import ByPactopia from './ByPactopia';
import Storage from '../../support/Storage';
import ReCAPTCHA from 'react-google-recaptcha';
import { FormControl } from '../../facturotopia';
import Loading from '../../facturotopia/loading/Loading';
import LoadingButton from '../../facturotopia/LoadingButton';
import ResponseError from '../../shared/responses/ResponseError';
import ResponseResult from '../../shared/responses/ResponseResult';

class AuthForgotPasswordEmail extends Component {

  state = {};

  recaptchaRef = null;

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      busy: false,
      restored: false,
      isLoggedIn: false,
      validator: new Validator({}, this.getRules({}))
    };

    this.recaptchaRef = createRef();
  }

  async componentDidMount() {
    let isLoggedIn = Auth.isAuthenticated();

    if (!Auth.isAuthenticated() && !!Auth.getUser()) {
      const data = await Storage.get('facturotopia');

      if (!!data) {
        Auth.setData(data);

        isLoggedIn = true;
      }
    } else {
      await Auth.logout();
    }

    if (isLoggedIn) {
      this.setState({
        isLoggedIn
      });
    } else {
      setTimeout(() => {
        this.setState({
          loaded: true
        });
      });
    }
  }

  getRules(data) {
    return {
      email: ['required', 'email'],
    }
  }

  validate(data) {
    const validator = new Validator(data, this.getRules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value
    }

    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes()
    });
  }

  handleOnSubmit = async () => {
    this.setState({
      busy: true,
      error: null
    });

    try {
      const token = await this.recaptchaRef.current.executeAsync();

      const params = {
        ...this.state.data,
        challenge: token
      }

      const query = QueryString.parse(this.props.location.search);

      const headers = {
        'X-Tenancy': query.tenancy
      }

      const response = await Http.post('/auth/password/email', params, { headers });

      this.setState({
        result: response,
        busy: false
      });
    } catch (error) {
      this.setState({
        error: error.data || error,
        busy: false
      });
    }
  }

  handleOnAction = () => {
    this.props.history.replace('/auth/login');
  }

  renderResult = () => {
    const { result } = this.state;

    return (
      <div className="result-container">
        <ResponseResult
          title="Solicitud recibida"
          result={ result }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          variant="inline"
          error={ error }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  onCaptchaChange = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        challenge: value
      }
    });
  }

  render() {
    const {
      data,
      isValid,
      isLoggedIn,
      busy,
      loaded,
      error,
      result
    } = this.state;

    const rules = this.getRules(data);

    if (isLoggedIn) {
      let { from } = this.props.location.state || { from: { pathname: '/app/dashboard' } };

      if (from.pathname === '/auth/login') {
        from.pathname = '/app/dashboard';
      }

      return <Redirect to="/bridge" state={ from } />;
    }

    if (!loaded) {
      return <Loading />
    }

    if (!loaded) {
      return <Row></Row>
    }

    if (result) {
      return this.renderResult();
    }

    return (
      <Form autoComplete="off">

        <div className="auth-content">
          <div className="avatar mt-4">
            <div className="auth-logo">
              <div className="d-flex justify-content-start">
                  <Image src="/img/logo.png"
                    className="auth-logo-img opacity-6"
                    fluid={ true }
                  />
                  <p className="title text-muted">Facturotöpia</p>
              </div>
            </div>
          </div>

          <div className="login-content">
            <div className="pb-3">
              <h6 className="text-muted">
                ¿Olvidaste tu contraseña?
              </h6>
            </div>

            <div className="form-box">
              <p className="text-muted">
                Ingresa el email asociado a tu cuenta y te enviaremos un correo con las instrucciones para resetear tu contraseña.
              </p>

              <FormControl type="email"
                name="email"
                placeholder="tu-email@ejemplo.com"
                autoFocus={ true }
                rules={ rules.email }
                value={ data.email }
                onChange={ this.handleOnChange }
              />

              <ReCAPTCHA
                size="invisible"
                ref={ this.recaptchaRef }
                sitekey={ process.env.REACT_APP_RECAPTCHA_KEY }
                onChange={ this.onCaptchaChange }
              />

              <Row>
                <Col className="text-right">
                  <LoadingButton type="button"
                    block={ true }
                    loading={ busy }
                    disabled={ !isValid || busy }
                    onClick={ this.handleOnSubmit }
                  >
                    { busy && 'Solicitando...'}
                    { !busy && 'Enviarme email' }
                  </LoadingButton>
                </Col>
              </Row>

              <div className="pt-3">
                { !!error && this.renderError() }
              </div>

              <Row>
                <Col className="text-right">
                  <Link to='/auth/login'>
                    Iniciar sesión
                  </Link>
                </Col>
              </Row>
            </div>
          </div>

          <div className="pt-4">
            <ByPactopia />
          </div>

        </div>
      </Form>
      )
    }
  }

  export default AuthForgotPasswordEmail;